export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-global-line' },
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line' },
  { slug: 'xiaoyuan', name: '校园', icon: 'ri-book-open-line' },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line' },
  { slug: 'xuanhuan', name: '玄幻', icon: 'ri-magic-line' },
  { slug: 'maoxian', name: '冒险', icon: 'ri-compass-3-line' },
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'jingsong', name: '悬疑', icon: 'ri-ghost-line' },
  { slug: 'zhanji', name: '战斗', icon: 'ri-sword-line' },
];

export const animeList = [
  {
    id: 1,
    title: '鬼灭之刃：无限列车篇',
    slug: 'guimie-zhi-ren-wuxian-lieche',
    category: 'rexue',
    image: 'https://readdy.ai/api/search-image?query=A%20Japanese%20anime%20demon%20slayer%20character%20with%20flame%20sword%20standing%20on%20a%20train%20at%20night%2C%20dramatic%20lighting%2C%20vibrant%20warm%20colors%2C%20anime%20art%20style%2C%20clean%20simple%20background%20with%20fire%20effects%2C%20high%20quality%20illustration&width=800&height=1120&seq=anime-card-01&orientation=portrait',
    rating: 9.5,
    episodes: 1,
    status: '已完结',
    year: 2020,
    description: '在蝴蝶屋结束修行的灶门炭治郎等人，抵达了下一个任务地点「无限列车」。在那里，短时间内就有四十多人失踪。炭治郎一行人，与鬼杀队的最强剑士「炎柱」炼狱杏寿郎会合，在行驶的列车上，与潜伏的鬼展开殊死搏斗。',
    tags: ['热血', '战斗', '奇幻'],
    featured: true,
  },
  {
    id: 2,
    title: '间谍过家家',
    slug: 'jiandie-guo-jiajia',
    category: 'gaoxiao',
    image: 'https://readdy.ai/api/search-image?query=A%20Japanese%20anime%20family%20portrait%20of%20a%20spy%20man%20assassin%20woman%20and%20telepath%20girl%20in%20elegant%20clothing%2C%20warm%20pastel%20colors%2C%20anime%20illustration%20style%2C%20clean%20simple%20background%2C%20heartwarming%20atmosphere&width=800&height=1120&seq=anime-card-02&orientation=portrait',
    rating: 9.3,
    episodes: 37,
    status: '连载中',
    year: 2022,
    description: '为了执行任务，西国能力最强的间谍「黄昏」被下令组建家庭。但他找到的「女儿」居然是会读心的超能力者，「妻子」是暗杀者？三人互相隐瞒真实身份，组成了一个临时家庭，开始了充满意外的共同生活。',
    tags: ['搞笑', '日常', '温馨'],
    featured: true,
  },
  {
    id: 3,
    title: '咒术回战',
    slug: 'zhoushu-huizhan',
    category: 'rexue',
    image: 'https://readdy.ai/api/search-image?query=A%20Japanese%20anime%20sorcerer%20boy%20with%20spiky%20hair%20fighting%20cursed%20spirits%20with%20supernatural%20powers%2C%20dark%20dramatic%20lighting%2C%20anime%20art%20style%2C%20clean%20background%20with%20energy%20effects%2C%20high%20contrast&width=800&height=1120&seq=anime-card-03&orientation=portrait',
    rating: 9.2,
    episodes: 48,
    status: '连载中',
    year: 2020,
    description: '高中生虎杖悠仁的祖父在去世前叮嘱他要尽可能帮助他人，之后他遭遇了来寻找「诅咒之王」两面宿傩手指的咒术师伏黑惠。为了保护同伴，虎杖吞下了宿傩的手指，成为了宿傩的容器，从此踏入了咒术师的世界。',
    tags: ['热血', '战斗', '奇幻'],
    featured: true,
  },
  {
    id: 4,
    title: '辉夜大小姐想让我告白',
    slug: 'huiye-daxiaojie-xiangrangwo-gaobai',
    category: 'lianai',
    image: 'https://readdy.ai/api/search-image?query=A%20Japanese%20romantic%20comedy%20anime%20scene%20with%20two%20students%20in%20school%20uniform%20blushing%20at%20each%20other%2C%20elegant%20academy%20setting%2C%20soft%20pink%20lighting%2C%20anime%20illustration%2C%20clean%20simple%20background%2C%20romantic%20atmosphere&width=800&height=1120&seq=anime-card-04&orientation=portrait',
    rating: 9.4,
    episodes: 38,
    status: '连载中',
    year: 2019,
    description: '在名门秀知院学园，学生会会长白银御行与副会长四宫辉夜，两人互相喜欢却因为自尊心过强，都认为「先告白就是输」，于是展开了一场让对方先告白的恋爱头脑战。',
    tags: ['恋爱', '搞笑', '校园'],
    featured: false,
  },
  {
    id: 5,
    title: '进击的巨人 最终季',
    slug: 'jinji-de-juren-zuizhongji',
    category: 'zhanji',
    image: 'https://readdy.ai/api/search-image?query=A%20Japanese%20anime%20soldier%20flying%20with%20gear%20fighting%20giant%20titans%20in%20a%20post%20apocalyptic%20world%2C%20dramatic%20cinematic%20lighting%2C%20anime%20art%20style%2C%20clean%20background%20with%20destruction%2C%20epic%20scale&width=800&height=1120&seq=anime-card-05&orientation=portrait',
    rating: 9.6,
    episodes: 35,
    status: '已完结',
    year: 2020,
    description: '为了赢得真正的自由，艾伦决定发动「地鸣」，驱使墙内的超大型巨人们踏平帕拉迪岛之外的整个世界。曾经的战友们为了阻止艾伦，组成了联合小队，踏上了最后的征途。',
    tags: ['战斗', '冒险', '奇幻'],
    featured: true,
  },
  {
    id: 6,
    title: '葬送的芙莉莲',
    slug: 'zangsong-de-fulilian',
    category: 'maoxian',
    image: 'https://readdy.ai/api/search-image?query=A%20Japanese%20anime%20elf%20mage%20girl%20with%20silver%20hair%20walking%20through%20a%20beautiful%20fantasy%20meadow%2C%20nostalgic%20warm%20lighting%2C%20anime%20art%20style%2C%20clean%20simple%20background%2C%20serene%20atmosphere&width=800&height=1120&seq=anime-card-06&orientation=portrait',
    rating: 9.7,
    episodes: 28,
    status: '连载中',
    year: 2023,
    description: '打倒魔王的勇者一行人中的魔法使芙莉莲，作为寿命悠长的精灵，她踏上了「了解人类」的旅程。在旅途中，她不断回忆起与逝去同伴们的点点滴滴，逐渐理解了人类的情感与生命的珍贵。',
    tags: ['冒险', '奇幻', '治愈'],
    featured: true,
  },
  {
    id: 7,
    title: '蓝色监狱',
    slug: 'lanse-jianyu',
    category: 'rexue',
    image: 'https://readdy.ai/api/search-image?query=A%20Japanese%20anime%20soccer%20player%20with%20intense%20eyes%20dribbling%20a%20ball%20on%20a%20futuristic%20blue%20field%2C%20dynamic%20action%20pose%2C%20anime%20art%20style%2C%20clean%20background%20with%20blue%20energy%2C%20competitive%20spirit&width=800&height=1120&seq=anime-card-07&orientation=portrait',
    rating: 8.9,
    episodes: 38,
    status: '连载中',
    year: 2022,
    description: '日本足球联盟为了培养出世界第一的前锋，召集了300名高中生前锋，将他们关入名为「蓝色监狱」的设施中进行残酷的淘汰训练。只有最后留下来的人，才能成为日本代表的前锋。',
    tags: ['热血', '运动', '竞技'],
    featured: false,
  },
  {
    id: 8,
    title: '孤独摇滚！',
    slug: 'gudu-yaogun',
    category: 'xiaoyuan',
    image: 'https://readdy.ai/api/search-image?query=A%20Japanese%20anime%20shy%20pink%20haired%20girl%20playing%20electric%20guitar%20nervously%20in%20a%20school%20band%20room%2C%20cute%20comedy%20style%2C%20anime%20illustration%2C%20clean%20simple%20background%2C%20slice%20of%20life%20vibe&width=800&height=1120&seq=anime-card-08&orientation=portrait',
    rating: 9.1,
    episodes: 12,
    status: '已完结',
    year: 2022,
    description: '极度社恐的少女后藤独，在初中时期开始自学吉他，梦想着组建乐队。进入高中后，她偶然被邀请加入了「纽带乐队」，开始了她一边克服社恐一边追逐音乐梦想的青春故事。',
    tags: ['校园', '音乐', '搞笑'],
    featured: false,
  },
  {
    id: 9,
    title: '石纪元',
    slug: 'shi-jiyuan',
    category: 'kehuan',
    image: 'https://readdy.ai/api/search-image?query=A%20Japanese%20anime%20boy%20with%20spiky%20green%20hair%20holding%20a%20science%20flask%20in%20a%20stone%20world%2C%20adventure%20sci%20fi%20theme%2C%20anime%20art%20style%2C%20clean%20simple%20background%2C%20primitive%20technology%20aesthetic&width=800&height=1120&seq=anime-card-09&orientation=portrait',
    rating: 8.8,
    episodes: 48,
    status: '连载中',
    year: 2019,
    description: '全人类因谜一般的现象被石化，数千年后，天才科学少年石神千空从石化中苏醒。在文明彻底毁灭的「石之世界」中，千空决心用科学的力量重建人类文明，从零开始创造一切。',
    tags: ['科幻', '冒险', '科普'],
    featured: false,
  },
  {
    id: 10,
    title: '迷宫饭',
    slug: 'migong-fan',
    category: 'maoxian',
    image: 'https://readdy.ai/api/search-image?query=A%20Japanese%20anime%20adventurer%20cooking%20monster%20food%20in%20a%20dungeon%20with%20party%20members%2C%20delicious%20looking%20food%2C%20anime%20art%20style%2C%20clean%20simple%20dungeon%20background%2C%20fantasy%20cuisine%20theme&width=800&height=1120&seq=anime-card-10&orientation=portrait',
    rating: 9.0,
    episodes: 24,
    status: '连载中',
    year: 2024,
    description: '冒险者莱欧斯的小队在迷宫深处遭遇了红龙，妹妹法琳被龙吞入腹中。为了在妹妹被消化前救出她，莱欧斯决定不再返回地面补给，而是在迷宫中「自给自足」——狩猎魔物，做成美味的料理。',
    tags: ['冒险', '美食', '奇幻'],
    featured: false,
  },
  {
    id: 11,
    title: '我推的孩子',
    slug: 'wotui-de-haizi',
    category: 'xuanhuan',
    image: 'https://readdy.ai/api/search-image?query=A%20Japanese%20anime%20idol%20girl%20with%20star%20eyes%20performing%20on%20stage%20with%20microphone%2C%20glittering%20spotlights%2C%20anime%20art%20style%2C%20clean%20simple%20background%2C%20show%20business%20theme&width=800&height=1120&seq=anime-card-11&orientation=portrait',
    rating: 9.2,
    episodes: 24,
    status: '连载中',
    year: 2023,
    description: '妇产科医生五郎在为偶像星野爱接生时被杀害，转生成为星野爱的孩子——阿库亚。他带着前世的记忆，与同样转生的双胞胎妹妹露比一起，在演艺圈中追寻着母亲的脚步和真相。',
    tags: ['玄幻', '偶像', '悬疑'],
    featured: true,
  },
  {
    id: 12,
    title: '夏日重现',
    slug: 'xiari-chongxian',
    category: 'jingsong',
    image: 'https://readdy.ai/api/search-image?query=A%20Japanese%20anime%20mystery%20scene%20on%20a%20summer%20island%20with%20a%20boy%20looking%20back%20suspiciously%2C%20sunset%20orange%20lighting%2C%20anime%20art%20style%2C%20clean%20simple%20background%2C%20suspenseful%20atmosphere&width=800&height=1120&seq=anime-card-12&orientation=portrait',
    rating: 8.7,
    episodes: 25,
    status: '已完结',
    year: 2022,
    description: '网代慎平回到故乡日都岛参加青梅竹马小舟潮的葬礼，却得知潮的死因并非意外，而是与岛上流传的「影子病」有关。更可怕的是，慎平发现自己陷入了一个不断重复的时间循环之中。',
    tags: ['悬疑', '奇幻', '轮回'],
    featured: false,
  },
];

export const articles = [
  {
    id: 1,
    title: '2024年最值得期待的十部新番动漫推荐',
    slug: '2024-xinfan-tuijian',
    excerpt: '新的一年又到了，动漫迷们最关心的莫过于即将播出的新番作品。我们精心挑选了十部2024年最值得期待的动漫新番，涵盖热血、恋爱、科幻等多种题材，快来看看有没有你心仪的作品吧！',
    content: `<p>2024年对于动漫迷来说无疑是令人兴奋的一年，众多备受期待的作品即将陆续播出。无论是经典IP的续作，还是全新的原创作品，都有着令人眼前一亮的潜力。下面，就让我们一起来看看2024年最值得期待的十部新番动漫吧。</p>

<h2>1. 《迷宫饭》第二季</h2>
<p>第一季凭借独特的「魔物料理」创意和温馨的冒险故事赢得了广泛好评。第二季将继续讲述莱欧斯一行人深入迷宫，一边烹饪魔物美食一边寻找拯救妹妹的方法。新的一季将会有更多奇特的魔物料理登场，同时主线剧情也将迎来重大转折。</p>

<h2>2. 《葬送的芙莉莲》第二季</h2>
<p>作为2023年口碑与人气双丰收的作品，《葬送的芙莉莲》以其细腻的情感描写和独特的叙事方式打动了无数观众。第二季将继续跟随芙莉莲的旅程，更多关于勇者辛美尔的回忆将被揭开，新的冒险与感动即将展开。</p>

<h2>3. 《咒术回战》新篇章</h2>
<p>在涩谷事变之后，咒术世界陷入了前所未有的混乱。新篇章将聚焦于虎杖悠仁和同伴们如何在绝境中寻找希望，对抗越来越强大的诅咒势力。更加紧张刺激的战斗场面即将呈现。</p>

<h2>4. 《鬼灭之刃》新剧场版</h2>
<p>继无限列车篇和大正小道消息之后，ufotable再度带来《鬼灭之刃》的全新剧场版。虽然具体剧情尚未公布，但以ufotable一贯的制作水准，相信这部作品一定会再次震撼所有观众的视觉神经。</p>

<h2>5. 《蓝色监狱》新赛季</h2>
<p>蓝色监狱的残酷淘汰仍在继续，洁世一能否在这场足球天才的修罗场中脱颖而出？新赛季将带来更加激烈的比赛，新的对手、新的挑战，以及对「自我」更深层次的拷问。</p>

<h2>6. 《我推的孩子》新篇章</h2>
<p>阿库亚的复仇之路仍在继续，而露比的偶像事业也迎来了新的发展。新篇章将深入挖掘演艺圈背后的真相，兄弟二人的命运将走向何方？悬疑与感动交织的故事不容错过。</p>

<h2>7. 《间谍过家家》新季度</h2>
<p>福杰一家的温馨（？）日常仍在继续！新季度将带来更多关于东西两国之间暗流涌动的剧情，黄昏的新任务、约尔的暗杀工作、安妮亚的校园生活，三条线将交织出更加精彩的故事。</p>

<h2>8. 《孤独摇滚！》第二季</h2>
<p>后藤独的摇滚之路才刚刚开始！第二季中，纽带乐队将面对更大的舞台和更多的挑战。社恐少女能否在摇滚的世界中找到属于自己的声音？让我们一起期待她的成长。</p>

<h2>9. 全新原创动画《星之彼方》</h2>
<p>由知名监督和豪华制作阵容打造的全新原创动画《星之彼方》，讲述了在遥远的未来，人类在星际间展开冒险的故事。精致的画面和宏大的世界观设定，让这部作品在播出前就备受关注。</p>

<h2>10. 《夏日重现》番外篇</h2>
<p>虽然主线故事已经完结，但《夏日重现》的世界仍有许多未被讲述的故事。番外篇将聚焦于日都岛上其他角色的故事，为我们展现这个夏天不同角度的精彩。</p>`,
    category: 'tuijian',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20collage%20of%20various%20Japanese%20anime%20characters%20from%20different%20series%2C%20vibrant%20colors%2C%202024%20new%20year%20theme%2C%20anime%20art%20style%2C%20clean%20composition%2C%20celebratory%20atmosphere&width=1200&height=630&seq=article-cover-01&orientation=landscape',
    author: '樱花酱',
    date: '2024-01-15',
    tags: ['新番', '推荐', '2024'],
    views: 9856,
  },
  {
    id: 2,
    title: '从《葬送的芙莉莲》看生命的意义：一部让人重新思考时间的作品',
    slug: 'fulilian-shengming-yiyi',
    excerpt: '《葬送的芙莉莲》不仅仅是一部冒险动漫，更是一部关于时间、生命和情感的作品。它用精灵芙莉莲漫长的生命跨度，让我们重新审视什么才是真正重要的东西。',
    content: `<p>在2023年的动漫作品中，《葬送的芙莉莲》无疑是最特别的那一个。它没有激烈的战斗，没有曲折的阴谋，却用最温柔的方式，击中了每个观众内心最柔软的地方。</p>

<h2>时间的尺度</h2>
<p>芙莉莲是寿命长达千年的精灵，对她而言，与勇者一行人的十年冒险只是生命中的一瞬间。然而正是这「一瞬间」，彻底改变了她的生命轨迹。</p>
<p>当勇者辛美尔去世后，芙莉莲才意识到自己错过了什么——那些本可以更多了解同伴的机会，那些本可以更加珍惜的日常。这种「失去后才懂得珍惜」的遗憾，是每个人都曾经历过的情感。</p>

<h2>了解人类</h2>
<p>芙莉莲的旅程主题是「了解人类」。但「了解人类」究竟意味着什么？</p>
<p>在与费伦和修塔尔克一同旅行的过程中，芙莉莲逐渐明白了——了解人类，不仅仅是理解人类的寿命为何如此短暂，更是理解人类为何明知生命有限，却依然能充满激情地活着。爱、友情、梦想、传承……正是这些看似「不理性」的情感，赋予了有限生命以无限的意义。</p>

<h2>记忆的力量</h2>
<p>作品中反复出现的主题是「记忆」。辛美尔虽然已经去世多年，但他的精神通过芙莉莲的记忆而延续。每一个被芙莉莲帮助过的人，都成为了辛美尔精神的继承者。</p>
<p>这让我们想到：一个人的生命虽然有限，但他所创造的价值、所传递的情感，却可以在他人的记忆中永远延续下去。这就是生命的意义所在——不在于活了多久，而在于如何被记住。</p>

<h2>结语</h2>
<p>《葬送的芙莉莲》用一个精灵的视角，让我们这些寿命有限的人类，看到了自己生命的珍贵。它温柔地提醒我们：不要等到失去后才懂得珍惜，要好好把握当下的每一刻，去爱，去感受，去创造值得被记住的回忆。</p>`,
    category: 'shenping',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Japanese%20anime%20elf%20girl%20with%20silver%20hair%20standing%20in%20a%20field%20of%20flowers%20at%20sunset%2C%20nostalgic%20and%20peaceful%20atmosphere%2C%20anime%20art%20style%2C%20warm%20golden%20lighting%2C%20emotional%20and%20contemplative%20mood&width=1200&height=630&seq=article-cover-02&orientation=landscape',
    author: '动漫研究员',
    date: '2024-02-20',
    tags: ['深度分析', '芙莉莲', '人生思考'],
    views: 7654,
  },
  {
    id: 3,
    title: '热血动漫TOP10盘点：那些让你燃到不行的经典作品',
    slug: 'rexue-dongman-top10',
    excerpt: '热血动漫一直是动漫界最受欢迎的类型之一。从经典老番到当下热门，我们盘点了十部最能让人热血沸腾的动漫作品，每一部都能让你看得停不下来！',
    content: `<p>热血动漫以其激昂的剧情、感人的友情和不屈的战斗精神，征服了一代又一代的动漫迷。今天我们为大家盘点十部不得不看的热血动漫神作，排名不分先后，每一部都值得你花时间去品味。</p>

<h2>1. 《鬼灭之刃》</h2>
<p>ufotable的顶级制作让这部作品从第一集就惊艳了所有人。炭治郎为救妹妹而踏上斩鬼之路的故事，充满了亲情、友情和不屈的意志。华丽的战斗场面配合感人至深的剧情，让《鬼灭之刃》成为了新时代热血动漫的代表作。</p>

<h2>2. 《咒术回战》</h2>
<p>MAPPA出品的又一力作。虎杖悠仁吞下宿傩手指的那一刻，就注定了他不平凡的命运。精妙的战斗系统设计、复杂的人物关系和不断升级的危机，让这部作品始终保持着高张力。</p>

<h2>3. 《进击的巨人》</h2>
<p>作为近十年来最具影响力的动漫之一，《进击的巨人》用其宏大的世界观和深刻的主题探讨，重新定义了热血动漫的边界。艾伦从复仇者到灭世者的转变，引发了无尽的讨论和思考。</p>

<h2>4. 《海贼王》</h2>
<p>连载超过20年的传奇作品，路飞和他的草帽一伙仍在向着伟大航路的终点前进。友情、梦想、自由，这些永恒的主题在海贼王的世界中得到了最极致的诠释。</p>

<h2>5. 《火影忍者》</h2>
<p>鸣人从一个被孤立的吊车尾成长为木叶英雄的故事，激励了无数人。「说到做到，就是我的忍道」这句话，至今仍回响在每个火影迷的心中。</p>

<h2>6. 《死神》</h2>
<p>黑崎一护意外获得死神之力后的冒险故事，以其独特的武器设计和帅气的卍解变身，在热血动漫中占据了不可替代的位置。</p>

<h2>7. 《我的英雄学院》</h2>
<p>在一个人人都有超能力的世界里，绿谷出久却生来无个性。但他对英雄的向往从未停止，最终继承了欧尔麦特的力量，向着最强英雄的目标不断前进。</p>

<h2>8. 《钢之炼金术师》</h2>
<p>爱德华兄弟为了复活母亲而进行禁忌炼成，却付出了沉重的代价。这部作品探讨了等价交换、生命价值等深刻主题，被誉为完美之作。</p>

<h2>9. 《一拳超人》</h2>
<p>埼玉老师用一拳解决所有敌人的设定看似荒诞，但作品中精彩的配角刻画和对英雄本质的探讨，让这部作品超越了单纯的搞笑番范畴。</p>

<h2>10. 《蓝色监狱》</h2>
<p>将足球与生存游戏相结合的创新设定，让这部作品在运动番中独树一帜。300名前锋争夺一个位置的残酷竞争，每一场比赛都让人手心冒汗。</p>`,
    category: 'tuijian',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Japanese%20anime%20collage%20of%20various%20action%20heroes%20fighting%20with%20explosive%20energy%20effects%2C%20warm%20fire%20colors%2C%20anime%20art%20style%2C%20epic%20cinematic%20composition&width=1200&height=630&seq=article-cover-03&orientation=landscape',
    author: '热血少年',
    date: '2024-03-08',
    tags: ['热血', '盘点', '经典'],
    views: 12340,
  },
  {
    id: 4,
    title: '动漫中的「治愈系」作品推荐：温暖你的每一个夜晚',
    slug: 'zhiyu-xi-zuopin-tuijian',
    excerpt: '生活节奏越来越快，有时候我们需要一部温暖治愈的动漫来放松心情。本文为你推荐五部能让你在忙碌一天后感到温暖与平静的治愈系动漫作品。',
    content: `<p>在快节奏的现代生活中，有时候我们需要的不是热血沸腾的战斗，不是烧脑的悬疑，而是一部能让心灵得到片刻安宁的「治愈系」动漫。这类作品通常以日常生活为背景，通过细腻的情感描写和温暖的故事，给观众带来心灵上的慰藉。</p>

<h2>1. 《摇曳露营△》</h2>
<p>这部作品讲述了女高中生们享受露营乐趣的故事。美丽的富士山风景、温暖的篝火、热腾腾的露营料理……每一个画面都散发着治愈的气息。看完后，你会不自觉地想要去露营，感受大自然的美好。</p>

<h2>2. 《日常》</h2>
<p>京都动画出品的经典之作。看似普通的日常生活，在角色的夸张演绎下变得妙趣横生。每一个笑点都恰到好处，每一个温情时刻都让人心头一暖。「我们所度过的每个平凡的日常，也许就是连续发生的奇迹」。</p>

<h2>3. 《夏目友人帐》</h2>
<p>夏目贵志将友人帐中的名字一一归还给妖怪的故事，充满了温柔与感动。每一集都是一个小故事，人与妖之间的羁绊，孤独与陪伴，都被细腻地描绘出来。这不仅仅是一部妖怪动漫，更是一部关于善良和理解的作品。</p>

<h2>4. 《三月的狮子》</h2>
<p>职业将棋棋士桐山零在孤独中成长，在与川本三姐妹的相处中逐渐找到归属感的故事。作品用纤细的笔触描绘了人与人之间的羁绊，温暖而深刻，每一集都能触动内心最柔软的地方。</p>

<h2>5. 《白兔糖》</h2>
<p>三十岁的单身男子大吉收养了外公的私生女——六岁的凛。两个年龄差距巨大的人开始了共同生活，在日常的点滴中建立起深厚的亲情。没有狗血的剧情，只有最纯粹的温暖与感动。</p>`,
    category: 'tuijian',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20warm%20and%20peaceful%20Japanese%20anime%20scene%20with%20characters%20enjoying%20a%20cozy%20campfire%20under%20starry%20night%20sky%2C%20soft%20pastel%20colors%2C%20anime%20art%20style%2C%20healing%20and%20calm%20atmosphere&width=1200&height=630&seq=article-cover-04&orientation=landscape',
    author: '温暖小站',
    date: '2024-03-22',
    tags: ['治愈', '日常', '推荐'],
    views: 6543,
  },
  {
    id: 5,
    title: '从动漫看日本文化：那些你不了解的日本传统元素',
    slug: 'dongman-riben-wenhua',
    excerpt: '动漫不仅仅是娱乐，它还是了解日本文化的一扇窗口。从神社到祭典、从茶道到剑道，动漫中蕴含着丰富的日本传统文化元素，让我们一起来探索吧。',
    content: `<p>动漫作为日本流行文化的重要组成部分，不仅是娱乐产品，更是日本文化输出的重要载体。在欣赏精彩剧情的同时，我们也能从中学到许多关于日本传统文化的知识。</p>

<h2>1. 神社与神道文化</h2>
<p>在《你的名字。》《夏目友人帐》等作品中，我们经常能看到神社的身影。神社是日本神道教的祭祀场所，鸟居是神社的入口标志。动漫中的角色常常在神社许愿、参加新年参拜（初詣），这些都是日本人日常生活的一部分。</p>

<h2>2. 祭典与浴衣</h2>
<p>夏日祭典是动漫中的经典桥段。《辉夜大小姐想让我告白》《月刊少女野崎君》等作品都有精彩的祭典剧情。浴衣、捞金鱼、苹果糖、烟花大会……这些充满日本风情的元素，构成了动漫中最浪漫的画面。</p>

<h2>3. 武士道与剑道</h2>
<p>以《鬼灭之刃》《浪客剑心》《死神》为代表的作品中，武士精神和剑道文化被反复呈现。忠诚、荣誉、自我牺牲——这些武士道的核心价值观通过动漫角色的行动被生动地展现出来。</p>

<h2>4. 茶道与和菓子</h2>
<p>《请问您今天要来点兔子吗？》《三月的狮子》等日常系作品中，常常出现茶道和和菓子的场景。茶道不仅是一种饮茶方式，更是一种追求「和敬清寂」精神境界的艺术。</p>

<h2>5. 温泉文化</h2>
<p>温泉回几乎是每部日常番的标配剧情。从《幸运星》到《摇曳露营△》，泡温泉的桥段层出不穷。温泉在日本不仅是一种休闲方式，更是一种社交活动。</p>

<h2>结语</h2>
<p>动漫是一扇通往日本文化的窗户。下次看动漫的时候，不妨多留意这些文化元素，它们会让你的观剧体验更加丰富，也能帮助你更好地理解故事背后的文化内涵。</p>`,
    category: 'wenhua',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Japanese%20anime%20scene%20of%20characters%20wearing%20yukata%20at%20a%20summer%20festival%20with%20lanterns%20and%20fireworks%2C%20traditional%20Japanese%20culture%20theme%2C%20anime%20art%20style%2C%20warm%20festive%20lighting%2C%20beautiful%20night%20scene&width=1200&height=630&seq=article-cover-05&orientation=landscape',
    author: '文化观察员',
    date: '2024-04-05',
    tags: ['日本文化', '传统', '科普'],
    views: 8876,
  },
  {
    id: 6,
    title: '动画制作流程揭秘：一部动漫是如何诞生的？',
    slug: 'donghua-zhizuo-liucheng',
    excerpt: '每一部我们看到的动漫背后，都凝聚着数百名制作人员的心血。从企划到播出，一部动漫的制作需要经历哪些环节？让我们带你走进动画制作的幕后世界。',
    content: `<p>当我们坐在屏幕前享受一部精彩的动漫时，可能很少会想到它背后所耗费的巨大工作量。一部12集的季番动画，通常需要1-2年的制作周期，涉及数百名工作人员。今天就让我们一起揭开动画制作的神秘面纱。</p>

<h2>1. 企划阶段</h2>
<p>一切始于一个企划。制作委员会（由出版社、电视台、动画公司等组成）决定制作某部作品后，首先需要确定监督（导演）、系列构成（总编剧）和角色设计等核心创作人员。</p>

<h2>2. 剧本创作</h2>
<p>系列构成根据原作（漫画或小说）编写每集的剧本大纲。剧本（脚本）详细描述每一场戏的对白、动作和场景变化。这是整个制作的基础，决定了作品的叙事节奏和情感走向。</p>

<h2>3. 分镜绘制</h2>
<p>监督根据剧本绘制分镜（絵コンテ），相当于电影的「故事板」。分镜决定了每一卡的构图、角色位置、镜头运动和时长，是整个动画的蓝图。</p>

<h2>4. 原画与动画</h2>
<p>原画师根据分镜绘制关键帧（原画），动画师则补充中间帧（動画）。一部20分钟的动画大约需要3000-5000张原画，这需要大量原画师夜以继日地工作。</p>

<h2>5. 上色与背景</h2>
<p>完成线稿后，进入上色（仕上げ）和背景美术阶段。如今大多使用数字工具完成，既能提高效率，也能实现更加丰富的视觉效果。</p>

<h2>6. 摄影与后期</h2>
<p>将角色和背景合成，添加光影、特效、镜头运动等。然后进行配音（アフレコ）、音效制作和背景音乐配乐。最后进行最终剪辑，一部完整的动漫作品就诞生了。</p>

<h2>结语</h2>
<p>动画制作是一门需要极大耐心和热情的艺术。每一帧画面背后，都有无数动画人的汗水和梦想。下次看动漫时，不妨在片尾字幕中留意那些名字——他们是真正的幕后英雄。</p>`,
    category: 'kepu',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Japanese%20animation%20studio%20workspace%20with%20animators%20drawing%20at%20desks%2C%20storyboards%20on%20walls%2C%20warm%20creative%20atmosphere%2C%20anime%20art%20style%2C%20behind%20the%20scenes%20documentary%20aesthetic&width=1200&height=630&seq=article-cover-06&orientation=landscape',
    author: '制作人笔记',
    date: '2024-04-18',
    tags: ['制作', '科普', '幕后'],
    views: 4321,
  },
];

export const articleCategories = [
  { slug: 'all', name: '全部文章' },
  { slug: 'tuijian', name: '动漫推荐' },
  { slug: 'shenping', name: '深度分析' },
  { slug: 'wenhua', name: '动漫文化' },
  { slug: 'kepu', name: '动画科普' },
];

export const testimonials = [
  {
    id: 1,
    name: '小明的动漫日记',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20profile%20avatar%20of%20a%20smiling%20boy%20with%20glasses%2C%20simple%20clean%20background%2C%20chibi%20style&width=100&height=100&seq=avatar-01&orientation=squarish',
    content: '樱花动漫是我每天必刷的网站！分类清晰，文章质量很高，每次都能在这里发现好看的番。特别是每周的新番推荐栏目，帮我省去了大量选番的时间。',
    role: '资深动漫迷',
  },
  {
    id: 2,
    name: '二次元小站',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20profile%20avatar%20of%20a%20girl%20with%20twin%20tails%2C%20simple%20clean%20background%2C%20chibi%20style&width=100&height=100&seq=avatar-02&orientation=squarish',
    content: '作为一个追番十多年的老二次元，樱花动漫的深度分析文章真的让我眼前一亮。不是简单的剧情介绍，而是真正有思考、有见地的内容。强烈推荐！',
    role: '追番达人',
  },
  {
    id: 3,
    name: '动漫前线',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cool%20anime%20style%20profile%20avatar%20of%20a%20character%20with%20headphones%2C%20simple%20clean%20background%2C%20chibi%20style&width=100&height=100&seq=avatar-03&orientation=squarish',
    content: '网站的UI设计非常漂亮，浏览体验很流畅。而且更新速度很快，新番播出后很快就有相关文章。已经推荐给了好多朋友，大家都说好！',
    role: '动漫博主',
  },
];

export const siteInfo = {
  name: '樱花动漫',
  tagline: '专注好看的动漫门户网站',
  description: '樱花动漫网是一个专注为动漫爱好者提供高质量动漫内容和资讯的门户网站。我们致力于为用户推荐好看到停不下来的动漫作品，提供深度的动漫分析和最新的动漫资讯，打造一个有温度、有深度的动漫社区。',
  email: 'contact@sakuraanime.com',
  phone: '400-888-9999',
  address: '广东省广州市天河区动漫产业园B座',
  qq: '1234567890',
  wechat: 'sakura_anime_official',
  foundedYear: 2020,
  totalUsers: 500000,
  totalArticles: 1280,
  dailyVisits: 80000,
};